import { FC } from 'react'

import { MultiSelectControl } from '@sequencehq/core-components'

import { useAllUsers } from 'common/hooks/useUsers'

export const UserMultiSelect: FC<{
  'data-testid'?: string
  values: string[]
  onChange: (value: string[]) => void
  isInvalid?: boolean
}> = ({ 'data-testid': dataTestId, values, onChange, isInvalid = false }) => {
  const { users, isPending } = useAllUsers()

  const options = users
    .map(user => ({
      label: user.label,
      value: user.id
    }))
    .sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
    )

  return (
    <MultiSelectControl
      data-testid={dataTestId}
      entityName="user"
      options={options}
      disabled={isPending}
      isInvalid={isInvalid}
      values={values}
      onChange={onChange}
    />
  )
}
